import type { CSSProperties, ReactNode } from 'react';
import type { SizeScale } from '@pv-frontend/design-tokens';
import { vars } from '../../theme/contract.css';
import type { Align, InlineAlign } from '../block-stack/block-stack';

type BlockAlign = 'start' | 'center' | 'end' | 'baseline' | 'stretch';

const blockAlignToItems: Record<BlockAlign, InlineAlign> = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
    baseline: 'baseline',
    stretch: 'stretch',
};

export type InlineStackProps = {
    children?: ReactNode;
    id?: string;
    /** Main-axis (horizontal) distribution → `justify-content`. */
    align?: Align;
    direction?: 'row' | 'row-reverse';
    /** Cross-axis (vertical) alignment → `align-items`. */
    blockAlign?: BlockAlign;
    gap?: SizeScale;
    wrap?: boolean;
    flex?: number;
};

/** Horizontal flex stack — mirrors the RN `InlineStack`. */
export function InlineStack({
    children,
    id,
    align,
    direction = 'row',
    blockAlign,
    gap,
    wrap = true,
    flex,
}: InlineStackProps) {
    const style: CSSProperties = {
        display: 'flex',
        flexDirection: direction,
        justifyContent: align,
        alignItems: blockAlign ? blockAlignToItems[blockAlign] : undefined,
        flexWrap: wrap ? 'wrap' : 'nowrap',
        gap: gap ? vars.space[gap] : undefined,
        flex,
    };
    return (
        <div id={id} style={style}>
            {children}
        </div>
    );
}
